import { css } from "@emotion/react"
import { useTranslation } from "@/hooks/useTranslation"

export const LoadingMessage = () => {
    const { t } = useTranslation()
    return (
        <p
            css={css`
                padding: 2em 0px;
                font-weight: bold;
                text-align: center;
            `}
        >
            {t("読み込み中です…")}
        </p>
    )
}
